import { StickerLabelVariant } from '@stitch-fix/mode-react';
import type { ShoppableOutfitProps } from '@stitch-fix/mode-react/ShoppableOutfit';

import type {
  ModeStickerLabel,
  ModeStickerLabelTheme,
} from '../types/definitions/vendor/graphql-schema.d';

export const themeMapping: Record<ModeStickerLabelTheme, StickerLabelVariant> =
  {
    DEFAULT_LIGHT: 'white',
    NAVY: 'navy',
    WHITE: 'white',
    CITRUS: 'citrus',
    MINT: 'mint',
    DEFAULT_INVERSE: 'navy',
    NAVY_CITRUS: 'navy-citrus',
    RED: 'red',
    CERULEAN: 'cerulean',
    KHAKI: 'khaki',
    CARGO: 'cargo',
    CHARCOAL: 'charcoal',
    BLUE_95: 'blue-95',
    MINT_95: 'mint-95',
    GRAY_99: 'gray-99',
    SHORELINE: 'shoreline',
    BUTTER: 'butter',
    DENIM: 'denim',
    BLUSH: 'blush',
    FOREST: 'forest',
    GRAPEFRUIT: 'grapefruit',
  };

type OutfitItemLabel = NonNullable<
  ShoppableOutfitProps['imageComponents'][number]['label']
>;

export const getOutfitStickerLabel = (
  sticker: Pick<ModeStickerLabel, 'label' | 'theme'>,
): OutfitItemLabel => ({
  text: sticker.label,
  // Mode 47.9 forwards this to StickerLabel, but its outfit type still lists only four colors.
  theme: themeMapping[sticker.theme] as OutfitItemLabel['theme'],
});
